import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

type TModule = {
  id: number,
  name: string,
  description: string,
  app: string,
  icon: string,
  path: string,
  active: boolean
}
type TModuleOptions = {
  id: number,
  key: string,
  show: boolean,
  string_value: string,
  numeric_value: number,
  type: string,
  company_id: number,
  module_id: number | null
}
type TCompany = {
  id: number
  document_number: string
  document_type: string
  alias: string,
  address: string,
  name: string,
  icon: string,
  modules: TModule[],
  uid: string | null,
  subscription?: any
}

type TCompanyContext = {
  current: TCompany,
  list: TCompany[],
  moduleList: TModule[],
  currentModule: TModule,
  moduleOptions: TModuleOptions[]
}
const initialState:TCompanyContext =  {
  current: {
    id: 0,
    document_number: '',
    document_type: '',
    alias: '',
    address: '',
    name: '',
    icon: '',
    modules: [],
    uid: null,
    subscription: null
  },
  list: [],
  moduleList: [],
  currentModule: {
    id: 0,
    name: '',
    description: '',
    app: '',
    icon: '',
    path: '',
    active: false
  },
  moduleOptions: []
}
interface CompanyContextType {
  company: TCompanyContext;
  updateCompany: (newConfig: Partial<TCompanyContext>) => void;
}
interface CompanyProviderProps {
  children: ReactNode;
}

const CompanyContext = createContext<CompanyContextType>({company:initialState,updateCompany:()=>{}});

export const CompanyProvider:React.FC<CompanyProviderProps> = ({ children }) => {
  const [company, setCompany] = useState(initialState);
  const updateCompany = useCallback((newConfig:Partial<TCompanyContext>) => {
    setCompany((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);
  
  const contextValue = useMemo(() => ({
    company,
    updateCompany,
  }), [company, updateCompany]);

  return (
    <CompanyContext.Provider value={contextValue}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  return useContext(CompanyContext);
};